import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { ArrowUp, X } from "lucide-react";

import { AtlasIcon, AtlasLauncher } from "./AtlasControl";

export function AtlasHelp({ locale, inSection }: { locale: "en" | "es"; inSection: boolean }) {
  const dialog = useRef<HTMLDialogElement>(null);
  const trigger = useRef<HTMLButtonElement>(null);
  const [question, setQuestion] = useState("");
  const [submitted, setSubmitted] = useState("");
  const [host, setHost] = useState<HTMLElement | null>(null);
  useEffect(() => { setHost(document.getElementById(inSection ? "atlas-section-anchor" : "atlas-home-anchor")); }, [inSection]);
  const es = locale === "es";
  function close() { dialog.current?.close(); trigger.current?.focus(); }
  const launcher = <AtlasLauncher ref={trigger} className={`atlas-launch${inSection ? " atlas-launch-section" : ""}`} onClick={() => dialog.current?.showModal()} aria-haspopup="dialog" aria-label={es ? "Consultar a Atlas" : "Ask Atlas"} />;
  return <>
    {host && createPortal(launcher, host)}
    <dialog ref={dialog} className="atlas-dialog" aria-labelledby="atlas-title" onCancel={close}>
      <header className="atlas-header atlas-panel-heading">
        <div className="atlas-identity"><span className="atlas-avatar"><AtlasIcon /></span><h2 id="atlas-title">Atlas</h2></div>
        <button type="button" onClick={close} aria-label={es ? "Cerrar Atlas" : "Close Atlas"}><X size={20} /></button>
      </header>
      <div className="atlas-conversation" aria-live="polite">
        <p className="atlas-introduction">{es ? "Consulta sobre los datos y documentos de tu proyecto." : "Ask about the information and documents for your project."}</p>
        {submitted && <p className="atlas-question">{submitted}</p>}
      </div>
      <form className="atlas-composer atlas-message-composer" onSubmit={(event) => { event.preventDefault(); if (question.trim()) { setSubmitted(question.trim()); setQuestion(""); } }}>
        <label className="sr-only" htmlFor="atlas-question">{es ? "Tu pregunta" : "Your question"}</label>
        <textarea id="atlas-question" value={question} onChange={(event) => setQuestion(event.target.value)} placeholder={es ? "Escribe tu pregunta" : "Type your question"} rows={3} />
        <button type="submit" disabled={!question.trim()} aria-label={es ? "Enviar pregunta" : "Send question"}><ArrowUp size={20} /></button>
      </form>
      <footer className="atlas-footer"><a href="mailto:support@globalmobility.law">{es ? "Contactar con soporte" : "Contact support"}</a></footer>
    </dialog>
  </>;
}
